import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getTimesheetApi,
  getTimeSheetListApi,
  ApproveTimesheetAPI,
  getGraphDetailsApi,
  RejectTimesheetAPI,
  RejectTimeOffAPI,
  ApproveTimeOffAPI,
  ApproveAllTimesheetAPI,
  editTimesheetAPI,
} from "../../API/API";
import { alertNotification } from "../../components/TopNotification/alertNotification";

function* getTimeSheetList(action) {
  try {
    const response = yield call(() => getTimeSheetListApi(action.payload));
    yield put({
      type: types.GET_TIMESHEET_LIST_SUCCESS,
      payload: response.data,
    });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_TIMESHEET_LIST_FAILURE, error });
  }
}

function* getTimeSheet(action) {
  try {
    const response = yield call(() =>
      getTimesheetApi(
        action.payload.userAssignmentId,
        action.payload.startdate,
        action.payload.enddate
      )
    ); // API Backend
    yield put({ type: types.GET_TIMESHEET_SUCCESS, payload: response.data });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_TIMESHEET_FAILURE, error });
  }
}

function* editTimesheet(action) {
  try {
    const { callBack, ...rest } = action.payload;
    const response = yield call(() => editTimesheetAPI(rest));
    if (response.status == 200) {
      callBack();
    }
    yield put({
      type: types.EDIT_TIMESHEET_SUCCESS,
      payload: response.data,
    });
    alertNotification("success", "Timesheet updated.");
  } catch (error) {
    alertNotification(
      "error",
      error.response.data.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong"
    );
    yield put({ type: types.EDIT_TIMESHEET_FAILURE, error });
  }
}
function* approveTimesheet(action) {
  try {
    const { callBack, ...rest } = action.payload;
    const response = yield call(() => ApproveTimesheetAPI(rest));
    if (response.status == 200) {
      callBack();
    }
    yield put({
      type: types.APPROVE_TIMESHEET_SUCCESS,
      payload: response.data,
    });
    alertNotification("success", "Timesheet approved successfully");
  } catch (error) {
    alertNotification(
      "error",
      error.response.data.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong"
    );
    yield put({ type: types.APPROVE_TIMESHEET_FAILURE, error });
  }
}

function* approveAllTimesheet(action) {
  try {
    const { callBack, ...rest } = action.payload;
    const response = yield call(() => ApproveAllTimesheetAPI(rest));
    if (response.status == 200) {
      callBack();
    }
    yield put({
      type: types.APPROVE_ALL_TIMESHEET_SUCCESS,
      payload: response.data,
    });
    alertNotification("success", "Timesheet approved successfully");
  } catch (error) {
    alertNotification(
      "error",
      error.response.data.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong"
    );
    yield put({ type: types.APPROVE_ALL_TIMESHEET_FAILURE, error });
  }
}

function* approveTimeOff(action) {
  try {
    const { callBack, ...rest } = action.payload;
    const response = yield call(() => ApproveTimeOffAPI(rest));
    if (response.status == 200) {
      callBack();
    }
    yield put({
      type: types.APPROVE_TIME_OFF_SUCCESS,
      payload: response.data,
    });
    alertNotification("success", "Leave approved successfully");
  } catch (error) {
    alertNotification(
      "error",
      error.response.data.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong"
    );
    yield put({ type: types.APPROVE_TIME_OFF_FAILURE, error });
  }
}
function* getGraphDetails(action) {
  try {
    const response = yield call(() => getGraphDetailsApi(action.payload));
    yield put({
      type: types.GET_GRAPH_DETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_GRAPH_DETAILS_FAILURE, error });
  }
}
function* rejectTimesheet(action) {
  try {
    const { callBack, ...rest } = action.payload;
    const response = yield call(() => RejectTimesheetAPI(rest));
    if (response.status == 200) {
      callBack();
    }
    alertNotification("success", "Timesheet rejected successfully");
    yield put({
      type: types.REJECT_TIMESHEET_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    alertNotification(
      "error",
      error.response.data.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong"
    );
    yield put({ type: types.GET_GRAPH_DETAILS_FAILURE, error });
    yield put({ type: types.REJECT_TIMESHEET_FAILURE, error });
  }
}
function* rejectTimeOff(action) {
  try {
    const { callBack, ...rest } = action.payload;
    const response = yield call(() => RejectTimeOffAPI(rest));
    if (response.status == 200) {
      callBack();
    }
    alertNotification("success", "Leave rejected successfully");
    yield put({
      type: types.REJECT_TIME_OFF_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    alertNotification(
      "error",
      error.response.data.errorMessage ||
        error?.message ||
        error ||
        "Something went wrong"
    );
    yield put({ type: types.REJECT_TIME_OFF_FAILURE, error });
  }
}

export function* watchGetTimesheetListSaga() {
  yield takeEvery(types.GET_TIMESHEET_LIST_REQUESTED, getTimeSheetList);
}

export function* watchGetTimesheetSaga() {
  yield takeEvery(types.GET_TIMESHEET_REQUESTED, getTimeSheet);
}

export function* watchEditTimesheetSaga() {
  yield takeEvery(types.EDIT_TIMESHEET_REQUESTED, editTimesheet);
}
export function* watchApproveTimesheetSaga() {
  yield takeEvery(types.APPROVE_TIMESHEET_REQUESTED, approveTimesheet);
}
export function* watchApproveAllTimesheetSaga() {
  yield takeEvery(types.APPROVE_ALL_TIMESHEET_REQUESTED, approveAllTimesheet);
}

export function* watchApproveTimeOffSaga() {
  yield takeEvery(types.APPROVE_TIME_OFF_REQUESTED, approveTimeOff);
}

export function* watchGetGraphDetailsSaga() {
  yield takeEvery(types.GET_GRAPH_DETAILS_REQUESTED, getGraphDetails);
}
export function* watchRejectTimesheetSaga() {
  yield takeEvery(types.REJECT_TIMESHEET_REQUESTED, rejectTimesheet);
}
export function* watchRejectTimeOffSaga() {
  yield takeEvery(types.REJECT_TIME_OFF_REQUESTED, rejectTimeOff);
}
